import * as constants from "../constants";

const PageBuilderRoute = {
    path: "/pagebuilder",
    displayName: "Page Builder",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH
    ]
};

const ModelComparisonRoute = {
    path: "/modelcomparison",
    displayName: "Comparison",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH
    ]
};


const LaneBuilderRoute = {
    path: "/lanebuilder",
    displayName: "Lane Builder",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH
    ]
};

const TesterRoute = {
    path: "/tester",
    displayName: "Tester",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH
    ],
    defaultForGroup: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH
    ]
};

// const PagesRoute = {
//     path: "/pages",
//     displayName: "Pages",
//     groups: [
//         constants.THE_FILTER_FULL_AUTH
//     ]
// };

const SlotsViewerRoute = {
    path: "/slots",
    displayName: "Slots Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.EPIX_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH,
        constants.TASTEMADE_FULL_AUTH
    ]
};

const FallbackViewerRoute = {
    path: "/fallbackviewer",
    displayName: "Fallback Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const SlotsEditorRoute = {
    path: "/slotseditor",
    displayName: "Slots Editor",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const ExperimentsRoute = {
    path: "/experiments",
    displayName: "Experiments",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const ModelConfigRoute = {
    path: "/modelconfig",
    displayName: "Configuration",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const SearchRoute = {
    path: "/search",
    displayName: "Search",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.EPIX_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH,
        constants.TASTEMADE_FULL_AUTH
    ],
    defaultForGroup: [
        constants.EPIX_FULL_AUTH
    ]
};

const MetadataRoute = {
    path: "/metadata",
    displayName: "Metadata",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH,
        constants.TASTEMADE_FULL_AUTH
    ],
    hide: true
};

const EntitiesRoute = {
    path: "/entities",
    displayName: "Search",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const EntitiesReportRoute = {
    path: "/entitiesreport",
    displayName: "Report",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const EntitiesDetailRoute = {
    path: "/entitiesdetail",
    displayName: "EntitiesDetail",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.RTVE_FULL_AUTH // only rtve_ful_auth (not read_auth!)
    ],
    hide: true
};

const MultiTaggingRoute = {
    path: "/multitagging",
    displayName: "Multi-Tagging",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const PromotionsRoute = {
    path: "/promotions",
    displayName: "Promotions",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const BlockingRoute = {
    path: "/blocking",
    displayName: "Blocking",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

// Analytics sub-routes
const CustomerOverviewRoute = {
    path: "/analytics/internal/customer-overview",
    displayName: "Customer Overview",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const BusinessImpressionsRoute = {
    path: "/analytics/internal/business-impressions",
    displayName: "Business Impressions",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const AdImpressionsRoute = {
    path: "/analytics/internal/ad-impressions",
    displayName: "Ad Impressions",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const KpiDashboardRoute = {
    path: "/analytics/external/kpi-dashboard",
    displayName: "KPI Dashboard",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const RecsDashboardRoute = {
    path: "/analytics/external/recs-dashboard",
    displayName: "Recs Dashboard",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const AnalyticsPlaygroundRoute = {
    path: "/analytics/external/playground",
    displayName: "Analytics Playground",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const DailyVideoEngagementRoute = {
    path: "/analytics/external/daily-video-engagement",
    displayName: "Daily Video Engagement",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const AnalyticsInternalRoute = {
    path: "/analytics/internal",
    displayName: "Internal",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    children: [
        CustomerOverviewRoute,
        BusinessImpressionsRoute,
        AdImpressionsRoute
    ]
};

const AnalyticsExternalRoute = {
    path: "/analytics/external",
    displayName: "External",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    children: [
        KpiDashboardRoute,
        RecsDashboardRoute,
        AnalyticsPlaygroundRoute,
        DailyVideoEngagementRoute
    ]
};

const AnalyticsRoute = {
    path: "/analytics",
    displayName: "Analytics",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    megaMenu: true,
    children: [
        AnalyticsInternalRoute,
        AnalyticsExternalRoute,
        // Flatten leaf routes for router to pick up
        KpiDashboardRoute,
        RecsDashboardRoute,
        CustomerOverviewRoute,
        BusinessImpressionsRoute,
        AdImpressionsRoute,
        AnalyticsPlaygroundRoute,
        DailyVideoEngagementRoute
    ]
};

const BrowseViewRoute = {
    path: "/browseview",
    displayName: "Browse",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const CollectionsRoute = {
    path: "/collections",
    displayName: "Collections",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const ModelManagerRoute = {
    path: "/modelmanager",
    displayName: "Model Manager",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ],
    defaultForGroup: [
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const ModelViewerRoute = {
    path: "/modelviewer",
    displayName: "Model Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const DynamicModelBuilderRoute = {
    path: "/dynamicmodelbuilder",
    displayName: "Dynamic Model Builder",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH
    ],
    hide: true
};

const PageManagerRoute = {
    path: "/pagemanager",
    displayName: "Page Manager",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH
    ]
};

const PageViewerRoute = {
    path: "/pageviewer",
    displayName: "Page Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const SystemHealthRoute = {
    path: "/systemhealth",
    displayName: "System Health",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const ChartsViewerRoute = {
    path: "/chartsviewer",
    displayName: "Charts",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const EventBridgeRoute = {
    path: "/eventbridge",
    displayName: "EventBridge",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const SeedViewerRoute = {
    path: "/seedviewer",
    displayName: "Seed Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const FilterRouting: RouteConfig[] = [
    {
        path: "/entities",
        displayName: "Entities",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            EntitiesRoute,
            EntitiesReportRoute,
            MultiTaggingRoute
        ]
    },
    SearchRoute,
    BrowseViewRoute,
    ChartsViewerRoute,
    {
        path: "/models",
        displayName: "Models",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            ModelConfigRoute,
            ModelManagerRoute,
            DynamicModelBuilderRoute,
            ModelViewerRoute,
            PageManagerRoute,
            PageViewerRoute
        ]
    },
    {
        path: "/slots",
        displayName: "Slots",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            SlotsEditorRoute,
            SlotsViewerRoute,
            TesterRoute,
            ExperimentsRoute,
            ModelComparisonRoute,
            FallbackViewerRoute
        ]
    },
    // Removed as unsupported currently
    // PagesRoute,
    {
        path: "/rules",
        displayName: "Rules",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            PromotionsRoute,
            BlockingRoute
        ]
    },
    {
        path: "/builders",
        displayName: "Builders",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            LaneBuilderRoute,
            PageBuilderRoute,
            CollectionsRoute
        ]
    },
    {
        path: "/monitoring",
        displayName: "Monitoring",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            SystemHealthRoute,
            EventBridgeRoute,
            SeedViewerRoute
        ]
    },
    AnalyticsRoute,
    
    MetadataRoute,
    EntitiesDetailRoute
];

const DemoRouting: RouteConfig[] = [
    TesterRoute,
    SlotsViewerRoute,
    LaneBuilderRoute,
    PageBuilderRoute,
    PromotionsRoute,
    BlockingRoute,
    {
        path: "/entities",
        displayName: "Entities",
        groups: [constants.DEMO_FULL_AUTH],
        children: [
            EntitiesRoute,
            MultiTaggingRoute
        ]
    },
    SearchRoute,
    BrowseViewRoute,
    MetadataRoute,
    EntitiesDetailRoute
];

const CustomerRouting: RouteConfig[] = [
    SlotsViewerRoute,
    LaneBuilderRoute,
    PromotionsRoute,
    BlockingRoute,
    SearchRoute,
    BrowseViewRoute,
    MetadataRoute
];

// const DemoCustomerRouting: RouteConfig[] = [
//     SlotsViewerRoute,
//     SearchRoute,
//     BrowseViewRoute,
//     MetadataRoute
// ];

const CustomerPageRouting: RouteConfig[] =
[
    ModelManagerRoute,
    SlotsViewerRoute,
    LaneBuilderRoute,
    PromotionsRoute,
    BlockingRoute,
    SearchRoute,
    BrowseViewRoute,
    MetadataRoute,
    PageBuilderRoute
];

const RTVERouting: RouteConfig[] =
[
    {
        path: "/models",
        displayName: "Models",
        groups: [constants.RTVE_FULL_AUTH, constants.RTVE_READ_AUTH],
        children: [
            ModelManagerRoute,
            DynamicModelBuilderRoute,
            ModelViewerRoute
        ]
    },
    {
        path: "/pages",
        displayName: "Pages",
        groups: [constants.RTVE_FULL_AUTH, constants.RTVE_READ_AUTH],
        children: [
            PageManagerRoute,
            PageViewerRoute
        ]
    },
    SlotsViewerRoute,
    ChartsViewerRoute,
    SearchRoute,
    BrowseViewRoute,
    PromotionsRoute,
    BlockingRoute,
    {
        path: "/entities",
        displayName: "Entities",
        groups: [constants.RTVE_FULL_AUTH, constants.RTVE_READ_AUTH],
        children: [
            EntitiesReportRoute,
            MultiTaggingRoute
        ]
    },
    MetadataRoute,
    SystemHealthRoute
];

export function getRoutingForGroup(groups: string[]): RouteConfig[] {
    if (groups?.includes(constants.THE_FILTER_FULL_AUTH)) {
        return FilterRouting;
    }

    if (groups?.includes(constants.DEMO_FULL_AUTH)) {
        return DemoRouting;
    }

    if (groups?.includes(constants.WAOO_FULL_AUTH) || groups?.includes(constants.TELENOR_FULL_AUTH)
        || groups?.includes(constants.BACKSTAGE_DEMO_FULL_AUTH)
        || groups?.includes(constants.SLOVAK_TELEKOM_FULL_AUTH)
    ) {
        return CustomerPageRouting;
    }

    if (
            groups?.includes(constants.RTVE_FULL_AUTH) ||
            groups.includes(constants.RTVE_READ_AUTH)
    ) {
        return RTVERouting;
    }


    return CustomerRouting;
}

export function getDefaultRoute(groups: string[]): string {
    if (groups.includes(constants.THE_FILTER_FULL_AUTH) || groups.includes(constants.DEMO_FULL_AUTH)) {
        return TesterRoute.path;
    }
    else if (
        groups.includes(constants.RTVE_FULL_AUTH)||
        groups.includes(constants.RTVE_READ_AUTH)
    ) {
        return ModelManagerRoute.path;
    }

    return SearchRoute.path;
}
